import request from '@/util/server.js'
// 登录模块

// 获取验证码
export function getTheCode (params) {
  return request({
    url: '/app/getCode',
    method: 'get',
    params
  })
}

// 登录
export function login (data) {
  return request({
    url: '/app/login',
    method: 'post',
    data
  })
}
// getFirstClassify: '/classify/getFirstClassify',

// 获取邮箱验证码
export function getEmailCode (params) {
  return request({
    url: '/app/send/emailVerificationCode',
    method: 'post',
    data: params
  })
}

// 邮箱注册
export function registerByEmail (params) {
  return request({
    url: '/app/register/emailVerify',
    method: 'post',
    data: params
  })
}

//  忘记密码-邮箱验证
export function forgetPassword (params) {
  return request({
    url: '/app/forgetPassword/emailVerify',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js